<template>
  <div id="page-wrapper" class="login-page-wrapper">
    <div id="page">
      <div class="main-page-content">
        <div id="main-wrapper" class="layout-main-wrapper clearfix">
          <div id="main" class="container">
            <div class="row row-offcanvas row-offcanvas-left clearfix">
              <main class="content-full-width" role="main">
                <section id="login" class="section" v-if="!reset">
                  <div class="d-login-container">
                    <div class="fptitle">
                      <span>{{ $t('message.vitamins') }}</span>
                      <span class="small text-white text-lowercase">{{ $t('message.for') }}</span>
                      <!--                      <img src="@/assets/images/destiny.png" class="login-logo" alt="">-->
                      <img v-if="company && logo" id="company-logo" class="login-logo" :src="logo" alt="Logo company">
                    </div>
                    <form autocomplete="on" class="user-login-form" method="post" @submit.prevent="onSubmit()">
                      <fieldset
                        class="js-form-item js-form-type-textfield form-type-textfield js-form-item-name form-item-name form-group">
                        <label for="edit-email" class="js-form-required form-required">
                          {{ $t('message.email') }}
                        </label>
                        <input v-model="email"
                               required
                               autocomplete="on"
                               autofocus="off"
                               type="text"
                               id="edit-email"
                               name="email"
                               value=""
                               size="60"
                               maxlength="60"
                               :placeholder="$t('message.email')"
                               class="form-text required form-control">
                      </fieldset>
                      <input type="text" class="d-none" autocomplete="on">
                      <fieldset
                        class="position-relative js-form-item js-form-type-password form-type-password js-form-item-pass form-item-pass form-group">
                        <label for="edit-pass" class="js-form-required form-required">
                          {{ $t('message.password') }}
                        </label>
                        <input v-model="password" :type="showPass ? 'text' : 'password'" id="edit-pass" name="pass" size="60" maxlength="128"
                               :placeholder="$t('message.password')" class="form-text required form-control">
                        <button type="button" class="score-c-4 mb-2 mr-2 togglepassword position-absolute btn btn-link p-0" @click.prevent.stop="showPass = !showPass">
                          <span v-if="!showPass" ><i class="fal fa-fw fa-eye"></i></span>
                          <span v-if="showPass" ><i class="fal fa-fw fa-eye-slash"></i></span>
                        </button>
                      </fieldset>
                      <div data-drupal-selector="edit-actions" class="form-actions js-form-wrapper form-group"
                           id="edit-actions">
                        <button type="submit" id="submit" name="login" value="Log in" class="button btn btn-primary">
                          {{ $t('message.log_in') }}
                        </button>
                      </div>

                      <ul class="errors" v-if="errors.length">
                        <li class="text-danger" v-for="e in errors">{{e}}</li>
                      </ul>
                    </form>
                  </div>
                  <div class="secondary-actions col-md-12 d-flex justify-content-between">
                    <div></div>
                    <button @click.stop.prevent="reset = true" class="pt-0 small btn btn-link text-white"><small
                      class="pr-1">{{$t('message.forgot_your_password')}}</small></button>
                  </div>
                </section>
                <section class="section" v-if="reset">
                  <div class="d-login-container reset-password">
                    <form autocomplete="on" class="user-login-form" method="post" @submit.prevent="onSubmit()">
                      <fieldset
                        class="js-form-item js-form-type-textfield form-type-textfield js-form-item-name form-item-name form-group">
                        <small class="d-block mb-2 text-white"><a @click.prevent="reset = false" href=""><
                          {{$t('message.back_to_login')}}</a></small>
                        <label for="edit-email" class="js-form-required form-required">
                          {{ $t('message.email') }}
                        </label>
                        <input v-model="email"
                               autocomplete="on"
                               autofocus="off"
                               type="text"
                               id="edit-email-forgot"
                               name="email"
                               value=""
                               size="60"
                               maxlength="60"
                               :placeholder="$t('message.email')"
                               class="form-text required form-control">
                      </fieldset>
                      <div data-drupal-selector="edit-actions" class="form-actions js-form-wrapper form-group"
                           id="edit-reset">
                        <button type="button" @click.prevent.stop="forgotPassword" id="reset" name="login"
                                value="Log in" class="button btn btn-primary">
                          {{ $t('message.submit') }}
                        </button>
                      </div>
                      <ul class="errors" v-if="errors.length">
                        <li class="text-danger" v-for="e in errors">{{e}}</li>
                      </ul>
                    </form>
                  </div>
                </section>

              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "../../store/store";

  export default {
    data() {
      return {
        showPass:false,
        reset: false,
        errors: [],
        email: '',
        password: ''
      }
    },
    computed: {
      logo() {
        let c = store.getters.getCompany;
        return c ? (c.Logo ? this.url + c.Logo.url : false) : false
      },
      company() {
        return store.getters.getCompany;
      },
    },
    methods: {
      validateLogin() {
        this.errors = [];
        let valid = true;
        if (this.email.length < 1) {
          valid = false;
          this.errors.push(this.$t('message.please_fill_in_email'))
        }


        return valid;
      },
      async forgotPassword(e) {
        const el = e.target;
        el.classList.add('loading');
        this.errors = [];
        //   console.log('clicked forgot pw', this.email)
        store.dispatch('forgotPassword', {email: this.email})
          .then(r => {
            this.errors.push(this.$t('message.reset_mail_sent'))
            // console.log('re', r)
            el.classList.remove('loading');
          })
          .catch(e => {
            el.classList.remove('loading');
            //   console.log('error', e)
            const messages = e.response.data.message;
            messages.forEach((messages, ind) => {
              messages.messages.forEach((message, ind) => {
                this.errors.push(message.message)
              })
            });
          })
      },
      async onSubmit() {
        this.errors = [];

        const formData = {
          email: this.email,
          password: this.password,
        };

        if (this.validateLogin()) {
          await store.dispatch('signin', {email: formData.email, password: formData.password, vm: this})
            .then(r => {
              // console.log(r)
            }).catch(e => {
            //  console.log('error', e.response)
              const messages = e.response.data.message;
              messages.forEach((messages, ind) => {
                messages.messages.forEach((message, ind) => {
                  // console.log('id', message.id)
                  // this.errors.push(message.message)
                  if (message.id === 'Auth.form.error.invalid') {
                    this.errors.push(this.$t('message.email_or_password_invalid'))
                  }
                  if (message.id === 'Auth.form.error.password.provide') {
                    this.errors.push(this.$t('message.please_provide_password'))
                  }
                })
              });
            })
        }
      }
    }
  }
</script>

<style>
  #company-logo {
    max-height: 50px;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Account/Signin.vue